{
    "warning": "OSTRZEŻENIE!",
    "message": "Nie wpisuj ani nie wklejaj kodu, którego nie rozumiesz.\nUżywanie tej konsoli może umożliwiać osobom, które wykorzystują atak Self-XSS, podszywanie się pod Ciebie i wykradanie informacji."
}
